import { useStateMachineValue } from "@/core/arch/state_machine";
import { useAdminApp } from "@/hooks/useAdminApp";

/**
 * Returns whether the signed-in admin belongs to a given Cognito group.
 *
 * The AuthGuard already requires `CPOS-Admin` to reach the app at all; this is
 * for finer-grained gating of individual actions (e.g. developer-only tools)
 * on top of that baseline. Reads the live `groups` claim from `AdminUserBloc`.
 */
export function useHasGroup(group: string): boolean {
  const { adminUserBloc } = useAdminApp();
  const [authState] = useStateMachineValue(adminUserBloc);
  return authState.groups.includes(group);
}
